import React, { useState } from 'react';
import { Skeleton } from './ui/skeleton';
import InlineScript from '@/components/InlineScript';

// Define the interface for the component props
interface FSFormEmbedProps {
  formstackID: string;
}

// Define the functional component with props
const FSFormEmbed: React.FC<FSFormEmbedProps> = ({ formstackID }) => {
  const [isScriptLoading, setIsScriptLoading] = useState(true);

  return (
    <div className='mx-auto w-full max-w-screen-md'>
      {isScriptLoading ? (
        <div className='block w-full'>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <Skeleton className='h-14 w-full rounded-xl' />
            <Skeleton className='h-6 w-full rounded-xl' />
          </div>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <div className='mb-2.5 space-y-1'>
              <Skeleton className='h-14 w-full rounded-xl' />
              <Skeleton className='h-6 w-full rounded-xl' />
            </div>
            <div className='mb-2.5 space-y-1'>
              <Skeleton className='h-14 w-full rounded-xl' />
              <Skeleton className='h-6 w-full rounded-xl' />
            </div>
            <div className='space-y-1'>
              <Skeleton className='h-14 w-full rounded-xl' />
              <Skeleton className='h-6 w-full rounded-xl' />
            </div>
          </div>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <Skeleton className='h-14 w-full rounded-xl' />
          </div>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <Skeleton className='h-14 w-full rounded-xl' />
          </div>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <Skeleton className='h-14 w-full rounded-xl' />
          </div>
          <div className='mb-5 flex flex-col space-y-1'>
            <Skeleton className='h-6 w-full rounded-xl' />
            <Skeleton className='h-64 w-full rounded-xl' />
          </div>
          <div className='flex items-center justify-center'>
            <Skeleton className='h-14 w-64 rounded-full' />
          </div>
        </div>
      ) : null}
      <InlineScript
        src={`https://nationalchildrensmuseum.formstack.com/forms/js.php/${formstackID}?useDynamicRendering=true&no_style_strict=1`}
        setIsScriptLoading={setIsScriptLoading}
        className='fsform'
      />
    </div>
  );
};

export default FSFormEmbed;
